module.exports = "https://preprod.web-phone.apps.phone.com/static/media/ProximaNova-Regular.d41d8cd9.otf";